// import React from 'react';
import { createStore, applyMiddleware, combineReducers, compose } from 'redux';
import thunk from 'redux-thunk';
import login from './reducers/login';
import dashboard from './reducers/dashboard';
import competitors from './reducers/competitors';
import updatePrice from './reducers/updatePrice';
import freezePrice from './reducers/freezePrice';
import reports from './reducers/reports';
import notification from './reducers/notification';
import priceActions from './reducers/priceActions';
import admin from './reducers/admin';
import delegateAccess from './reducers/delegate-access';
import ecri from './reducers/ecri';
import { composeWithDevTools } from 'redux-devtools-extension';

const initialState = {};

let middleWares = [thunk];

let composeEnhancer = compose(
  composeWithDevTools(applyMiddleware(...middleWares))
);

const store = createStore(
  combineReducers({
    login,
    dashboard,
    notification,
    updatePrice,
    freezePrice,
    reports,
    priceActions,
    delegateAccess,
    admin,
    competitors,
    ecri
  }),
  initialState,
  composeEnhancer
);
export default store;
